module.exports = __webpack_public_path__ + "static/media/student-experience.1a6600eb.png";